/** Shared labels and URLs for the host menu and Workforce child routes. */
export const WORKFORCE_SECTIONS = [
  { path: 'overview', label: 'Overview' },
  { path: 'attrition', label: 'Attrition Trend' },
  { path: 'claims', label: 'Expense Pressure' },
  { path: 'project-expenses', label: 'Project Expenses' },
  { path: 'leave', label: 'Leave Map' },
  { path: 'risk', label: 'Group Risk' },
];
